import React from 'react';

const YesNoDialog = ({ show, model, onClosePopup }) => {
    const [showDialog, setShowDialog] = React.useState(show);

    React.useEffect(() => {
        setShowDialog(show);
    }, [show]);
    
    const onClose = React.useCallback(() => {
        if (onClosePopup) onClosePopup();
    });
    const yes = React.useCallback((e) => {
        e.stopPropagation();
        if (onClosePopup) onClosePopup();
        if (model?.onYes) model.onYes();
    });
    const no = React.useCallback((e) => {
        e.stopPropagation();
        if (onClosePopup) onClosePopup();
        if (model?.onNo) model.onNo();
    });
    return (
        (showDialog &&
            <div className="dialogBox" xstyle="display:block;background-color: #00000082;"
                onClick={onClose}>
                <div className="dialogBoxWindow" style={{ width: "300px" }}>
                    <header>
                        <a className="close cursor">X</a>
                    </header>
                    <main>

                        <div style={{ padding: "10px 5px 5px 5px", textAlign: "center" }}>
                            <p >{model.message || "Having fun?"}</p>
                        </div>

                    </main>
                    <footer>
                        <div style={{ padding: "10px 5px 5px 5px", textAlign: "center" }}>
                            <a className="simpleButtonOutLine" onClick={yes} style={{ width: "100px" }}>
                                Yes
                            </a>
                            <a className="simpleButtonOutLine" onClick={no} style={{ width: "100px" }}>
                                No
                            </a>
                        </div>
                    </footer>
                </div>
            </div>
        )
    )
};

export default YesNoDialog;

